import { render, staticRenderFns } from "./DeleteColorModal.vue?vue&type=template&id=5b9dd16e&scoped=true"
import script from "./DeleteColorModal.vue?vue&type=script&lang=js"
export * from "./DeleteColorModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteColorModal.vue?vue&type=style&index=0&id=5b9dd16e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9dd16e",
  null
  
)

export default component.exports